<!--
 * @Author: cong
 * @Date: 2021-11-11 20:15:10
 * @LastEditTime: 2021-11-20 14:02:04
 * @LastEditors: cong
 * @Description: 
 * @FilePath: \qlh-vue-web\src\views\cwcapitals\report\list.vue
-->
<template>
  <div class="tab-body">
    <el-row>
      <el-col :span="24" class="context">
        <el-date-picker
          v-model="value3"
          type="year"
          placeholder="选择年"
          value-format="yyyy"
          @change="changeYear"
        >
        </el-date-picker>
        <el-card
          class="box-card"
          :body-style="{ height: '100%', padding: '10px' }"
        >
          <div id="months" style="height: 100%"></div>
        </el-card>
        <el-card>
          <div v-if="biao">
            <qlh-table
              class="table"
              :data="biao"
              stripe
              v-loading="listLoading"
              show-summary
            >
              <qlh-table-column
                type="index"
                width="50"
                label="序号"
                fixed="left"
              ></qlh-table-column>
              <qlh-table-column
                prop="cptdate"
                label="日期"
                sortable
              ></qlh-table-column>
              <qlh-table-column
                prop="income"
                label="收入（元）"
                sortable
              ></qlh-table-column>
              <qlh-table-column
                prop="expenditure"
                label="支出（元）"
                sortable
              ></qlh-table-column>
              <qlh-table-column
                prop="zong"
                label="小计（元）"
                sortable
              ></qlh-table-column>
            </qlh-table>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import qlhTable from "@/components/qlhTable/qlhTable.vue";
import qlhTableColumn from "@/components/qlhTable/qlhTableColumn.vue";
import "echarts/lib/chart/bar";
import api from "@/api/cw/cwcapitals.js";
export default {
  components: {
    qlhTable,
    qlhTableColumn,
  },
  data() {
    return {
      listLoading: false,
      //表
      biao: [],
      //合计
      zong: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      //收入
      income: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      //支出
      expenditure: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      //时间年
      value3: "",
    };
  },
  methods: {
    list() {
      let date = new Date();
      this.value3 = date.format("yyyy");
      this.getData();
    },
    makePiePicture(dom) {
      // 基于准备好的dom，初始化echarts实例
      let myChart = this.$echarts.init(document.getElementById(dom));
      let date = new Date();

      let option = {
        title: {
          text: this.value3 + "-月流水分析",
        },
        tooltip: {
          trigger: "axis",
        },
        legend: {
          data: ["合计", "收入", "支出"],
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        toolbox: {
          show: true,
          feature: {
            dataZoom: {
              yAxisIndex: "none",
            },
            dataView: { readOnly: false },
            magicType: { type: ["line", "bar"] },
            saveAsImage: {},
          },
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: [
            "一月",
            "二月",
            "三月",
            "四月",
            "五月",
            "六月",
            "七月",
            "八月",
            "九月",
            "十月",
            "十一月",
            "十二月",
          ],
        },
        yAxis: {
          type: "value",
          name: "单位（元）",
          axisLabel: {
            formatter: "{value}",
          },
        },
        color: ["#7B68EE", "#32CD32", "#DC143C"],
        series: [
          {
            name: "合计",
            type: "line",
            data: this.zong,
            itemStyle: {
              normal: {
                label: {
                  show: true,
                  position: "top",
                },
              },
            },
          },
          {
            type: "line",
            name: "收入",
            data: this.income,
            itemStyle: {
              normal: {
                label: {
                  show: true,
                  position: "top",
                },
              },
            },
          },
          {
            type: "line",
            name: "支出",
            data: this.expenditure,
            itemStyle: {
              normal: {
                label: {
                  show: true,
                  position: "top",
                },
              },
            },
          },
        ],
      };

      myChart.setOption(option);
    },

    getData() {
      this.listLoading = true;
      let arr = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
      let parameter = {
        cptdate: this.value3,
      };
      let parameters = this.$utils.merger(parameter);
      api.getReport(parameters, (response) => {
        this.biao = response.data;
        for (const iterator of response.data) {
          for (const year of arr) {
            console.log(Number.parseInt(iterator.cptdate.split("-")[1]));
            if (Number.parseInt(iterator.cptdate.split("-")[1]) == year) {
              this.zong[year - 1] = iterator.zong;
              this.income[year - 1] = iterator.income;
              this.expenditure[year - 1] = iterator.expenditure;
            }
          }
        }
        this.makePiePicture("months");
        this.listLoading = false;
      });
    },
    //触发年
    changeYear() {
      this.zong = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
      //收入
      this.income = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
      //支出
      this.expenditure = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
      this.getData();
    },
  },
  mounted() {
    this.list();
  },
};
</script>

<style lang="scss" scoped="scoped">
@import "~common/custom/css/common.scss";

.context {
  text-align: center;
}
</style>
